// extracted by mini-css-extract-plugin
export default {"WrapperPrompt":"WrapperPrompts_WrapperPrompt__BJb0F","PromptItem":"WrapperPrompts_PromptItem__-2ZLw","title":"WrapperPrompts_title__Dh6aM","text":"WrapperPrompts_text__Ww4AS"};